import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '上游新闻答题系统';
const baseUrl = 'SYDT0814';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'answer',
      name: `${baseUrl}-answer`,
      component: () => import('./pages/Answer.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
